import { Alert, Button } from "react-bootstrap";
import { ApplyFailure } from "./helpers";

interface Props {
  failures: ApplyFailure[];
  // Services from this attempt that did reach the project.
  appliedCount: number;
  onContinue: () => void;
}

// Stays on screen (unlike a toast) so the reasons can be read and corrected
// before applying again.
const ApplyFailuresAlert = ({ failures, appliedCount, onContinue }: Props) => {
  if (!failures.length) return null;

  const notAdded = failures.filter((f) => !f.applied).length;

  return (
    <Alert variant="danger" className="applyFailures">
      <Alert.Heading as="h6">
        {notAdded
          ? `${notAdded} service${
              notAdded > 1 ? "s" : ""
            } could not be added. Correct the issues below and apply again.`
          : "Some changes could not be saved."}
      </Alert.Heading>
      <ul className="mb-2">
        {failures.map((f, i) => (
          <li key={`${f.serviceId}-${i}`}>
            <strong>{f.name}</strong>: {f.message}
            {f.applied && (
              <em>
                {" "}
                (the service was added to the project; this change was not)
              </em>
            )}
          </li>
        ))}
      </ul>
      {appliedCount > 0 && (
        <Button variant="outline-danger" size="sm" onClick={onContinue}>
          Go to project ({appliedCount} added)
        </Button>
      )}
    </Alert>
  );
};

export default ApplyFailuresAlert;
